import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const MarieClaireUK: Site = {
  id: 'marieclaireuk',
  logo: 'svg/marieclaire.svg',
  label: 'Marie Claire',
  analyticsName: 'marieclaireuk',
  hostname: 'marieclaire.co.uk',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, article a, #ise-root a`, // Standard articles & Marie Claire Edit
};
